export default (t) => ({
  display_options: {
    compare: 'year',
    invoicing: {
      sum_by: 'count'
    },
    dossier: {
      based_on: 'death_date'
    }
  },
  rows: [
    {
      id: 'R1',
      type: 'simple',
      label: 'global.dossier',
      elements: [
        {
          id: 'R1.1',
          type: 'dossier',
          title: t('global.nb_dossier'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R1.2',
          type: 'dossier',
          title: t('global.burial_dossier'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            based_on: 'death_date',
            properties: ['burial']
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R1.3',
          type: 'dossier',
          title: t('global.cremation_dossier'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            based_on: 'death_date',
            properties: ['cremation']
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R1.4',
          type: 'dossier',
          title: t('attributes.infection'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            based_on: 'death_date',
            properties: ['infection']
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R1.5',
          type: 'dossier',
          title: t('attributes.destitute'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            based_on: 'death_date',
            properties: ['destitute']
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        }
      ]
    },
    {
      id: 'R2',
      type: 'simple',
      label: 'global.invoicing',
      elements: [
        {
          id: 'R2.0',
          type: 'invoicing',
          title: t('global.invoices') + ' ' + t('global.tax_included'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'invoicing#doc_type',
              values: 'INV',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            sum_by: 'total_tvac'
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R2.1',
          type: 'invoicing',
          title: t('global.invoice_hors_debours'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'invoicing#doc_type',
              values: 'INV',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null,
            sum_by: 'total_hors_debours'
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        }
      ]
    },
    {
      id: 'R3',
      type: 'simple',
      label: 'global.events',
      elements: [
        {
          id: 'R3.2',
          type: 'event',
          title: t('global.total_ceremonies'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'CER',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.1',
          type: 'event',
          title: t('attributes.coffin_placing'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'COP',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.3',
          type: 'event',
          title: t('global.cremations'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'CRE',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.4',
          type: 'event',
          title: t('global.visites'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'VIS',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: ['type#VIS'],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.8',
          type: 'event',
          title: t('global.receptions'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'REC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.9',
          type: 'event',
          title: t('global.wakes'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'WAK',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.10',
          type: 'event',
          title: t('global.thanatopraxies'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'THAN',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.11',
          type: 'event',
          title: t('global.transfers'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'TRA',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.12',
          type: 'event',
          title: t('global.inhumations'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'BUR',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.13',
          type: 'event',
          title: t('global.ashes_recoveries'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'ASR',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.14',
          type: 'event',
          title: t('global.dispersions'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'DIS',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        },
        {
          id: 'R3.15',
          type: 'event',
          title: t('global.exhumations'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#type',
              values: 'EXH',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: null
          },
          thumbnail: {
            chart_type: null,
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'line'
          }
        }
      ]
    },
    {
      id: 'R3P',
      type: 'multi',
      label: 'global.places',
      elements: [
        {
          id: 'R3.5',
          type: 'event',
          title: t('global.cemeteries'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#place_type',
              values: 'CIM',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'place'
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'doughnut'
          }
        },
        {
          id: 'R3.6',
          type: 'event',
          title: t('global.churches'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#place_type',
              values: 'EGL',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'place'
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'doughnut'
          }
        },
        {
          id: 'R3.7',
          type: 'event',
          title: t('global.crematoriums'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'event#place_type',
              values: 'CRE',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            properties: [],
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'place'
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'doughnut'
          }
        }
      ]
    },
    {
      id: 'R5',
      type: 'multi',
      label: 'global.dossier',
      elements: [
        {
          id: 'F1',
          type: 'dossier',
          title: t('attributes.gender'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'genre',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F2',
          type: 'dossier',
          title: t('attributes.age'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'age',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F3',
          type: 'dossier',
          title: t('attributes.DOM'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'residence_city',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F5',
          type: 'dossier',
          title: t('attributes.dossier_type'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'type',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F6',
          type: 'dossier',
          title: t('global.dossier_status'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'status',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F7',
          type: 'dossier',
          title: t('attributes.inhumation_type'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'burial_type',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        // {
        //   id: 'F9',
        //   type: 'dossier',
        //   title: 'Lieu de repos',
        //   options: {
        //     x_axis: {
        //       type: 'date',
        //       compare: true,
        //       compare_type: 'year'
        //     },
        //     stack: 'resting_place',
        //     based_on: 'death_date',
        //     properties: []
        //   },
        //   thumbnail: {
        //     chart_type: 'doughnut',
        //     chart_compare: false, format: 'extended',
        //     options: {
        //       x_axis: {
        //         compare: false
        //       }
        //     }
        //   },
        //   detailed: {
        //     chart_type: 'bar'
        //   }
        // },
        {
          id: 'F10',
          type: 'dossier',
          title: t('global.thanatopraxie'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'thanato_type',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'F11',
          type: 'dossier',
          title: t('attributes.funerailles_type'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'dossier#type',
              values: 'DEC',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'funeral_type',
            based_on: 'death_date',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        }
      ]
    },
    {
      id: 'R6',
      type: 'multi',
      label: 'global.items',
      elements: [
        {
          id: 'G1',
          type: 'invoice_item',
          title: t('attributes.sold_types'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'invoicing#doc_type',
              values: 'INV',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'item_category',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        },
        {
          id: 'G2',
          type: 'invoice_item',
          title: t('attributes.category_types'),
          filters: [
            {
              column: 'common#date_relative',
              values: 'this_year',
              condition: '=',
              whereType: 'where'
            },
            {
              column: 'invoicing#doc_type',
              values: 'INV',
              condition: '=',
              whereType: 'where'
            }
          ],
          options: {
            x_axis: {
              type: 'date',
              compare: true,
              compare_type: 'year'
            },
            stack: 'invoicing_category',
            properties: []
          },
          thumbnail: {
            chart_type: 'doughnut',
            chart_compare: false,
            format: 'extended',
            options: {
              x_axis: {
                compare: true
              }
            }
          },
          detailed: {
            chart_type: 'bar'
          }
        }
      ]
    }
  ]
})
